import React from "react"
import { useActiveBlock } from "app/regions/hooks/use-active-block"
import { getSource } from "../setting-utils"

export const ASPECT_RATIOS = {
  landscape: "56.25%", // 16:9 aspect ratio; 6 ÷ 9
  portrait: "133%", // 3:4 aspect ratio; 4 ÷ 3
  square: "100%" // 1:1 aspect ratio; 1 ÷ 1
}

export function Image({ data, block_id, properties }) {
  const { src, alt, url } = data.properties
  const crop = properties.crop || "none"
  const { setActiveBlockId } = useActiveBlock()
  const handleImageClick = () => {
    setActiveBlockId(block_id)
  }

  const handleLinkClick = e => {
    e.preventDefault()
  }

  const handleBlur = () => {
    setActiveBlockId(null)
  }

  const source = getSource(src, { crop })

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleLinkClick}
      style={{
        display: "block",
        position: "relative",
        border: "none",
        cursor: "pointer"
      }}
    >
      {/* eslint-disable-next-line */}
      <img
        src={source}
        alt={alt}
        onClick={handleImageClick}
        onBlur={handleBlur}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: crop === "none" ? "relative" : "absolute",
          borderRadius: properties.radius,
          left: 0,
          top: 0
        }}
      />
      <div
        className="pointer-events-none"
        style={{
          paddingBottom: ASPECT_RATIOS[properties.crop]
        }}
      />
    </a>
  )
}
